export enum PaymentStatus{
    Open,
    Canceled,
    Pending,
    Expired,
    Failed,
    Paid
}